// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconList: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path
                fill="currentColor"
                d="M6,12 C9.3046875,12 12,9.3046875 12,6 C12,2.6953125 9.3046875,0 6,0 C2.6953125,0 0,2.6953125 0,6 C0,9.3046875 2.6953125,12 6,12 Z M5.4375,8.0625 L5.4375,6.5625 L3.9375,6.5625 C3.6328125,6.5625 3.375,6.3046875 3.375,6 C3.375,5.6953125 3.6328125,5.4375 3.9375,5.4375 L5.4375,5.4375 L5.4375,3.9375 C5.4375,3.6328125 5.6953125,3.375 6,3.375 C6.3046875,3.375 6.5625,3.6328125 6.5625,3.9375 L6.5625,5.4375 L8.0625,5.4375 C8.3671875,5.4375 8.625,5.6953125 8.625,6 C8.625,6.3046875 8.3671875,6.5625 8.0625,6.5625 L6.5625,6.5625 L6.5625,8.0625 C6.5625,8.3671875 6.3046875,8.625 6,8.625 C5.6953125,8.625 5.4375,8.3671875 5.4375,8.0625 Z"
            />
        </svg>
    );
};

export default React.memo(IconList);
